module.exports = __webpack_public_path__ + "img/25-l.f792e49b.png";